import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import config from './config'

class Fire {
  initialize() {
    const firebaseConfig = {
      apiKey: config().FIREBASE_API_KEY,
      authDomain: config().FIREBASE_AUTH_DOMAIN,
      databaseURL: config().FIREBASE_DATABASE_URL,
      projectId: config().FIREBASE_PROJECT_ID,
      storageBucket: config().FIREBASE_STORAGE_BUCKET,
      messagingSenderId: config().FIREBASE_MESSAGE_SENDER_ID,
      appId: config().FIREBASE_APP_ID,
      measurementId: config().FIREBASE_MEASUREMENT_ID,
    }

    const app = initializeApp(firebaseConfig)

    this.DB = getFirestore(app)
    this.Auth = getAuth(app)
  }
}

export default new Fire()
